import { AddIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Checkbox,
    Collapse, Flex, Icon, Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio, RadioGroup,
    Select,
    Switch,
    Table, Tbody,
    Td,
    Text, Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import { useMemo, useState } from 'react';
import { BsStars } from 'react-icons/bs';
import { FiChevronUp } from 'react-icons/fi';
import { MdClose, MdEdit, MdOutlineEdit } from 'react-icons/md';
import PhoneInput from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import { useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_Awareness_Traffic_Engagement,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { removeEmptyValues, truncateName, truncateString } from 'utils/functions';
import { object, string } from "yup";
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';
import UrlParametersUpdate from '../UrlParametersUpdate';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';
import { FaEye } from 'react-icons/fa';
import AdPreviewImage from '../AdPreviewImage';
import AdPreviewVideo from '../AdPreviewVideo';

let schema = object().shape({
    destinationType: string(),
    type: string()
        .required('Type is required'),
    link: string()
        .when('destinationType', {
            is: (value) => !['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(value),
            then: () => string().required('Link is required'),
            otherwise: () => string().notRequired(),
        }),
    phoneNumber: string().when('destinationType', {
            is: (value) => ['PHONE_CALL', 'WEBSITE_AND_PHONE_CALL'].includes(value),
            then: () =>
              string()
                .transform((value) => {
                  if (value == null) return '';
                  return String(value).replace(/^tel:\+?/, '');
                })
                .matches(/^[0-9]{12,15}$/, 'Phone number must be between 10 and 15 digits')
                .required('Phone number is required'),
            otherwise: () => string().notRequired(),
          }),
})

function SingleMediaUpdateForm({ adData, destinationType, creative, creatives, adAccount, onDelete, onChangeImage, onAiModalOpen, objective }) {

    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const boxBorder = useColorModeValue("gray.300", "purple.800");

    const toast = useToast();
    const [isCollapsed, setisCollapsed] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const { isOpen: isAdPreviewModalOpen, onOpen: onAdPreviewModalOpen, onClose: onAdPreviewModalClose } = useDisclosure();
    const userInfo = useSelector((state) => state.auth?.userInfo);

    const [updateAdspressocreativeAds, { isLoading: isAdspressoAdsetUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});
    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adAccount?.adsAccountId}, {skip: !adAccount?.adsAccountId});

    const { description, image_hash, link, message, name, thumbnail, url, video_id, _id, type, url_tags, fileName, contextual_multi_ads, asset_feed_spec, caption, degrees_of_freedom_spec, template_url_spec, lead_gen_form_id, page_welcome_message } = creative || {}

    const formattedPageIds = useMemo(() => {
        if (!adData?.adsAccounts?.length || !adAccount?.adsAccountId) return [];

        const matchedAccount = adData.adsAccounts.find(
            acc => acc.adsAccountId === adAccount.adsAccountId
        );

        return matchedAccount?.page_id ? [matchedAccount.page_id] : [];
    }, [adData, adAccount]);

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || !['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType) }
    );

    const singleMediaFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: name || '',
            message: message || '',
            description: description || '',
            type: type,
            link: link || '',
            caption: caption || '',
            lead_gen_form_id: lead_gen_form_id || '',
            phoneNumber: destinationType === 'WEBSITE_AND_PHONE_CALL' ? asset_feed_spec?.call_ads_configuration?.phone_number?.replace('tel:+', '') : link?.includes('tel:+') ? link.replace('tel:+', '') : '',
            url: url || '',
            url_tags: url_tags || '',
            fileName: fileName || '',
            destinationType: destinationType,
            enroll_status: contextual_multi_ads?.enroll_status ? contextual_multi_ads?.enroll_status : 'OPT_OUT',
            pac_relaxation_enroll_status: degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN',          
            app_product_page_id: asset_feed_spec?.app_product_page_id,
            app_id: template_url_spec?.config?.app_id || '',
            page_welcome_message: page_welcome_message,
        },
        validationSchema: schema,
        onSubmit: (values, { resetForm }) => {

            const { phoneNumber, name, description, message, url, type, link, url_tags, fileName, enroll_status, app_product_page_id, caption, app_id, pac_relaxation_enroll_status, lead_gen_form_id, page_welcome_message } = values;
            let link_, type_, asset_feed_specs;
            if (phoneNumber?.length > 0 && destinationType === 'WEBSITE_AND_PHONE_CALL'){
                asset_feed_specs = {
                    call_ads_configuration: {
                        call_destination_type : "WEBSITE_AND_CALL",
                        phone_number: `tel:+${phoneNumber}`
                    }
                };
                link_ = link;
                type_ = type;
            }else if(phoneNumber?.length > 0 && destinationType === 'PHONE_CALL') {
                link_ = `tel:+${phoneNumber}`;
                type_ = type;
            } else {
                link_ = link;
                type_ = type;
            }

            let videoId = video_id ? { video_id } : null;
            let imageHash = image_hash ? { image_hash } : null;
            let thumbnail_ = thumbnail ? { thumbnail } : null;

            const payload = {
                name,
                fileName,
                contextual_multi_ads: {
                    enroll_status,
                },
                ...(destinationType === 'WEBSITE_AND_PHONE_CALL' ? 
                        {
                            asset_feed_spec : asset_feed_specs,
                        }
                    : {
                        asset_feed_spec: {
                            app_product_page_id,
                        },
                    }
                ),
                description,
                ...(message?.trim() && { message }),
                url,
                lead_gen_form_id,
                link: link_,
                type: type_,
                ...(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", 'OUTCOME_LEADS'].includes(objective) && {
                    ...(!['CALL_NOW', 'LIKE_PAGE'].includes(type_) && { caption }),
                    ...(type_ !== 'LIKE_PAGE' && !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType) ? {
                      degrees_of_freedom_spec: {
                        creative_features_spec: {
                          pac_relaxation: { enroll_status: pac_relaxation_enroll_status }
                        }
                      }
                    } : {})
                }),
                ...((objective === "OUTCOME_AWARENESS" || destinationType === 'ON_VIDEO') && {
                    template_url_spec: { config: { app_id } },
                }),
                ...((['WHATSAPP'].includes(destinationType)) && { page_welcome_message }),
                ...(url_tags?.trim() && { url_tags }),
                ...thumbnail_,
                ...videoId,
                ...imageHash
            };

            const filteredPayload = removeEmptyValues(payload);

            try {
                updateAdspressocreativeAds({ adcreativeId: _id, payload: filteredPayload }).unwrap()
                    .then(response => {
                        toast({
                            position: "top-right",
                            title: "Ad creative updated",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                    })
                    .catch(error => {
                        const errorMessage = error?.data?.message || "An unexpected error occurred";
                        const formattedMessage = errorMessage.replace(/['"]/g, '');

                        toast({
                            position: "top-right",
                            title: "Error updating Ad creative",
                            description: formattedMessage,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                    });
            } catch (error) {
                console.log(error);

            } finally {
                setisCollapsed(false);
                resetForm();
            }
        }
    });

    const handleUrlChange = (constructedUrl) => {
        singleMediaFormik.setFieldValue('link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        singleMediaFormik.setFieldValue('url_tags', constructedUrl);
    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === formattedPageIds[0]);

    return (
        <>

            <Modal
                isOpen={isAdPreviewModalOpen}
                onClose={onAdPreviewModalClose}
                size="3xl"
                scrollBehavior={"inside"}
            >
                <ModalOverlay />
                <ModalContent minH={'60vh'}>
                    <ModalHeader>Ad preview</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {creative && adData ? (() => {
                            const isImage = creative?.image_hash && !creative?.asset_feed_spec?.ad_formats && !creative?.product_set_id;
                            const isVideo = creative?.video_id && !creative?.asset_feed_spec?.ad_formats && !creative?.product_set_id;

                            if (isImage) {
                            return (
                                <AdPreviewImage
                                    file={creative}
                                    adData={adData}
                                    creatives={creatives}
                                />
                            );
                            }

                            if (isVideo) {
                            return (
                                <AdPreviewVideo
                                    file={creative}
                                    creatives={creatives}
                                    adData={adData}
                                />
                            );
                            }

                            return <Text>No preview available</Text>;
                        })() : null}
                    </ModalBody>
                    <ModalFooter justifyContent={'flex-start'} css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }} py={2}>
                        <Text fontSize={'14px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={singleMediaFormik.values.page_welcome_message}
                onSave={(updatedData) => {
                    singleMediaFormik.setFieldValue('page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />
            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={singleMediaFormik?.values} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={singleMediaFormik?.values} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Box key={url} p={1} borderWidth={1} borderRadius="md" borderColor={boxBorder}>
                <Flex alignItems="center" gap={2} justify="space-between">
                    <Flex alignItems="center" gap={2}>
                        {url ?
                            image_hash?.length > 0 ? (
                                <img
                                    src={url}
                                    alt={name}
                                    style={{ width: '48px', height: '36px', objectFit: 'cover', borderRadius: '3px' }}
                                />
                            ) : (
                                <video
                                    src={url}
                                    style={{ width: '48px', height: '36px', objectFit: 'cover', borderRadius: '3px' }}
                                />
                            ) : (
                                <AddIcon boxSize={5} ml={2} mr={2} />
                            )}
                        <Flex direction={'column'}>
                            <Text fontSize="10px" noOfLines={1}>
                                {name}
                            </Text>

                            <Flex gap={1}>
                                {singleMediaFormik.values.description ? (
                                    <Text fontSize="10px" noOfLines={1}>{truncateName(singleMediaFormik.values?.description)}</Text>
                                ) : (
                                    <Text fontSize="10px">Enter a description</Text>
                                )}
                            </Flex>
                        </Flex>

                    </Flex>
                    <Flex alignItems="center" gap={'5px'}>
                        <Tooltip label="Edit copy" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={isCollapsed ? FiChevronUp : MdEdit}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={() => userInfo?.role === 'client' && setisCollapsed(!isCollapsed)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Ad preview" fontSize="xs">
                            <Box>
                                 <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={FaEye}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={onAdPreviewModalOpen}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Remove creative" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.400' }}
                                    as={MdClose}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    boxSize={5}
                                    onClick={() => userInfo?.role === 'client' && onDelete(_id)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'red.500'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                    </Flex>
                </Flex>
                <Collapse in={isCollapsed}>
                    <Box p={'10px'}>
                        <Flex direction={'column'}>

                            <Flex position="relative" alignItems="center" gap={4} p={2} borderRadius="md" bg={backgroundColor}>
                                {url ? (
                                    image_hash?.length > 0 ? (
                                        <img
                                            src={url}
                                            alt={name}
                                            style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '5px', cursor: 'pointer' }}
                                        />
                                    ) : (
                                        <video
                                            src={url}
                                            // controls
                                            style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '5px', cursor: 'pointer' }}
                                        />
                                    )
                                ) : (
                                    <Box p={4}>
                                        <Button
                                            bg={'gray.50'}
                                            borderWidth={1}
                                            size="sm"
                                            onClick={() => {
                                                onChangeImage(creative, adAccount);
                                            }}
                                        >
                                            {image_hash?.length > 0 ? 'Select Image' : 'Select Video'}
                                        </Button>
                                    </Box>
                                )}

                                {/* {url ?
                                <Box position="absolute" top={2} right={2} cursor="pointer" zIndex={1}>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>
                                                    Remove Image
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <CloseIcon
                                            mb={2}
                                            color="red.500"
                                            boxSize={3}
                                            pointerEvents="all"
                                            onClick={() => {
                                                onRemoveImage(_id);
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                                : null
                            } */}

                                {url ?
                                    <Flex direction={'column'} gap={2}>
                                        <Flex>
                                            <Button
                                                bg={'gray.50'}
                                                size="xs"
                                                borderWidth={1}
                                                onClick={() => {
                                                    onChangeImage(creative, adAccount);
                                                }}
                                            >
                                                {image_hash?.length > 0 ? 'Change Image' : 'Change Video'}
                                            </Button>
                                        </Flex>
                                        {image_hash?.length > 0 ?
                                            <Flex alignItems={'center'} gap={2}>
                                                <Button
                                                    colorScheme='brand'
                                                    size="xs"
                                                    onClick={() => {
                                                        onAiModalOpen(creative, adAccount);
                                                    }}
                                                    leftIcon={<BsStars />}
                                                >
                                                    AI Image Generation
                                                </Button>

                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                                            <Text fontWeight={'bold'}>Generated with AI</Text>
                                                            <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                                            <Flex direction={'column'} gap={2}>
                                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                                            </Flex>
                                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                                        </Flex>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            :
                                            <Flex alignItems={'center'} gap={2}>
                                                <Button
                                                    colorScheme='brand'
                                                    size="xs"
                                                    onClick={() => {
                                                        onAiModalOpen(creative, adAccount);
                                                    }}
                                                    leftIcon={<BsStars />}
                                                >
                                                    AI Video Generation
                                                </Button>

                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                                            <Text fontWeight={'bold'}>AI Video Generation</Text>
                                                            <Text>AI-generated video ads are created using your product information and visuals. By assembling product highlights, voiceovers, and dynamic visuals, the AI helps generate high-performing video ads optimised for various platforms.</Text>
                                                            <Flex direction={'column'} gap={2}>
                                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                                <Text>Product URL Based: Extracts product details from your URL to auto-generate video content.</Text>
                                                                <Text>Asset Based: Uses your uploaded visuals to create fully edited video ads.</Text>
                                                            </Flex>
                                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                                                        </Flex>
                                                    }
                                                    fontSize="md"
                                                    >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                        }
                                    </Flex>
                                    : null
                                }
                            </Flex>

                            {["OUTCOME_AWARENESS","OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) && singleMediaFormik?.values?.type !== "LIKE_PAGE" && !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType) ? 
                                    <Flex direction={'column'} gap={2} mb={4}>
                                        <Flex alignItems="center">
                                            <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                                        <Text fontWeight={'bold'}>Flexible media</Text>
                                                        <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                                        <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                                    </Flex>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Flex alignItems={'center'} gap={2}>
                                            <Switch size={'sm'} colorScheme='brand' isChecked={singleMediaFormik.values.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => singleMediaFormik.setFieldValue('pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                            <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                                        </Flex>
                                    </Flex>
                            : null}

                            {/* Multi-advertiser ads Section */}
                            <Flex direction="column" mb={4} borderRadius="md" gap={2}>
                                <Checkbox
                                    onChange={(e) => {
                                        singleMediaFormik.setFieldValue("enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                    }}
                                    colorScheme="brand"
                                    isChecked={singleMediaFormik.values.enroll_status === 'OPT_IN'}
                                >
                                    <Flex align={'center'}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                </Checkbox>
                            </Flex>

                            <Box mb={'0px'} mt={'10px'}>
                                {Boolean(adData?.useFileName) ? (
                                    <Flex mb={4} direction="column" gap={2}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontSize={'14px'} fontWeight="bold">Ad name</Text>
                                        </Flex>
                                        <Input
                                            placeholder="Ad name"
                                            name="fileName"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={singleMediaFormik.values.fileName}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                    </Flex>
                                ) : null}

                                <Flex mb={4} direction="column" gap={2}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontSize={'14px'} fontWeight="bold">Primary text</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>
                                                        The primary text for your ad appears in most placements, though the position
                                                        varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                                                        characters or less.
                                                    </Text>
                                                </Box>
                                            }
                                            fontSize="md">
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        placeholder="Tell people what your ad is about..."
                                        name="message"
                                        size={'sm'}
                                        borderRadius="md"
                                        value={singleMediaFormik.values.message}
                                        onChange={singleMediaFormik.handleChange}
                                    />
                                </Flex>
                                
                                {singleMediaFormik?.values?.type === "LIKE_PAGE" ? null :
                                    <Flex mb={'20px'} direction="column" gap={2}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontSize={'14px'} fontWeight="bold">Headline</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>
                                                            Add up to five brief headlines to let people know what your ad is about. Each
                                                            headline can have a maximum of 255 characters. Headlines won't appear in all
                                                            placements.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md">
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Input
                                            placeholder="Write a short headline"
                                            name="name"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={singleMediaFormik.values.name}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                    </Flex>
                                }

                                {(destinationType === 'APP' || singleMediaFormik?.values?.type === "LIKE_PAGE") ? null :
                                    <Box direction="column" mb={'15px'}>
                                        <Flex alignItems="center" mb={'8px'} gap={2}>
                                            <Text fontSize={'14px'} fontWeight="bold">Description</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>
                                                            Add up to five link descriptions to emphasize why people should visit your
                                                            website. This won't appear in all placements.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Textarea
                                            placeholder="Include additional details"
                                            name="description"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={singleMediaFormik.values.description}
                                            onChange={singleMediaFormik.handleChange}
                                            rows={2}
                                        />
                                    </Box>
                                }

                                {singleMediaFormik?.values?.type === "LIKE_PAGE" ? null :
                                    <Box direction="column" mb={'20px'}>
                                        <Flex alignItems="center" mb={'8px'} gap={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Call to action</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Select
                                            name="type"
                                            borderRadius={'md'}
                                            value={singleMediaFormik.values.type}
                                            onChange={singleMediaFormik.handleChange}
                                            size={'sm'}
                                            isDisabled={singleMediaFormik.values.type === 'CALL_NOW' || (destinationType === 'WHATSAPP' && objective === 'OUTCOME_LEADS')}
                                        >
                                            {singleMediaFormik.values.type === 'CALL_NOW' ? (
                                                <option value={'CALL_NOW'}>
                                                    Call Now
                                                </option>
                                            ) : ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType) ? (
                                                <>
                                                    {call_to_action_options_instantForms?.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : destinationType === 'APP' && objective === 'OUTCOME_APP_PROMOTION' ? (
                                                <>
                                                    {call_to_action_options_app_promptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : destinationType === 'APP' && ['OUTCOME_SALES','OUTCOME_LEADS'].includes(objective) ? (
                                                <>
                                                    {call_to_action_options_for_app_leads_and_sales.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                             ) : destinationType === 'WHATSAPP' ? (
                                                <>
                                                    {call_to_action_options_whatsapp.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : objective === 'OUTCOME_AWARENESS' || (["OUTCOME_ENGAGEMENT","OUTCOME_TRAFFIC"].includes(objective) && destinationType === 'WEBSITE') || destinationType === 'ON_VIDEO'  ? (
                                                <>
                                                {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                                </>
                                            ) :
                                                <>
                                                    {call_to_action_options?.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            }
                                        </Select>
                                    </Box>
                                }

                                {['WEBSITE', 'ON_VIDEO', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType) || objective === 'OUTCOME_AWARENESS' ? (
                                    <>
                                        <Flex mb={4} direction="column">
                                            <Flex alignItems="center" gap={2} mb={'10px'}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Website URL</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                            <Text>Enter the URL for the webpage you want people to visit</Text>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Flex direction={'column'} gap={1}>
                                                <Input
                                                    type="url"
                                                    name="link"
                                                    borderRadius={'md'}
                                                    placeholder="Enter URL"
                                                    value={singleMediaFormik.values.link}
                                                    onChange={singleMediaFormik.handleChange}
                                                    size={'sm'}
                                                />
                                                <Flex mt={2}>
                                                    <Button onClick={() => {
                                                        setUrlModalOpen(true)
                                                    }}
                                                        variant="link"
                                                        color='brand'>
                                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                                    </Button>
                                                </Flex>
                                                {singleMediaFormik.touched.link && singleMediaFormik.errors.link ? (
                                                    <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.link}</Text>
                                                ) : null}
                                            </Flex>
                                        </Flex>
                                    </>
                                ) : null}

                                {destinationType === 'APP' && objective === 'OUTCOME_APP_PROMOTION' ? (
                                    <>
                                        <Flex mb={4} direction="column" gap={2}>
                                            <Flex alignItems="center" gap={2}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                            <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                            <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                            <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                            <Box>
                                                                <Text>* Android app link</Text>
                                                                <Text>* Custom URL scheme</Text>
                                                                <Text>* Facebook app link</Text>
                                                            </Box>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Input
                                                type="url"
                                                name="link"
                                                borderRadius={'md'}
                                                placeholder="Enter URL"
                                                value={singleMediaFormik.values.link}
                                                onChange={singleMediaFormik.handleChange}
                                                size={'sm'}
                                            />
                                        </Flex>
                                        <Flex mb={4} direction="column" gap={2}>
                                            <Flex alignItems="center" gap={2}>
                                                <Text fontWeight="bold" fontSize="14px">Custom store listing</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                            <Text fontWeight="bold">Using a custom store listing</Text><br />
                                                            <Text mb={2}>A custom store listing ID sends people to a landing page you've customized...</Text>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Input
                                                placeholder="Enter custom store listing ID"
                                                name="app_product_page_id"
                                                size={'sm'}
                                                borderRadius="md"
                                                value={singleMediaFormik.values.app_product_page_id}
                                                onChange={singleMediaFormik.handleChange}
                                            />
                                        </Flex>
                                    </>
                                ) : null}

                                {destinationType === 'APP' && ['OUTCOME_SALES','OUTCOME_LEADS'].includes(objective) ? (
                                    <>
                                        <Flex mb={4} direction="column" gap={2}>
                                            <Flex alignItems="center" gap={2}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                                <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                           <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Input
                                                type="url"
                                                name="link"
                                                borderRadius={'md'}
                                                placeholder="Enter the deep link URL"
                                                value={singleMediaFormik.values.link}
                                                onChange={singleMediaFormik.handleChange}
                                                size={'sm'}
                                            />
                                        </Flex>
                                    </>
                                ) : null}

                                {singleMediaFormik?.values?.type === 'CALL_NOW' || destinationType === 'WEBSITE_AND_PHONE_CALL' ? (
                                    <>
                                        <Box mb={4}>
                                            <Text fontWeight="bold" fontSize={'14px'} mb={'10px'}>Call now</Text>
                                            <PhoneInput
                                                country={'in'}
                                                value={singleMediaFormik?.values?.phoneNumber}
                                                onChange={(value) => {
                                                    singleMediaFormik.setFieldValue('phoneNumber', value)
                                                }}
                                                inputProps={{
                                                    name: 'phoneNumber',
                                                    required: true,
                                                    autoFocus: true,
                                                }}
                                                enableSearch={true}
                                                searchPlaceholder="Search"
                                            />

                                            {singleMediaFormik.touched.phoneNumber && singleMediaFormik.errors.phoneNumber ? (
                                                <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.phoneNumber}</Text>
                                            ) : null}
                                        </Box>
                                    </>
                                ) : null}

                                {['WHATSAPP'].includes(destinationType) ? (
                                    <>
                                        <Flex mb={2}>
                                            <Text fontWeight={'bold'} fontSize={'sm'}>Message template</Text>
                                        </Flex>
                                    
                                        {(() => {
                                        const welcomeData = singleMediaFormik?.values?.page_welcome_message;

                                        const type = welcomeData?.text_format?.customer_action_type;

                                        const greeting = welcomeData?.text_format?.message?.text || '';
                                        const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                        const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                        return (
                                            <Box mb={2}>
                                                <Box border={'1px solid'} borderColor={boxBorder} p={2} borderRadius={'md'} bg={backgroundColor}>
                                                    <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                                    {type === 'autofill_message' && (
                                                        <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                                    )}

                                                    {type === 'ice_breakers' && (
                                                        <>
                                                        <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                        {iceBreakers.map((q, i) => (
                                                            <Text key={i} fontSize="14px">
                                                            {i + 1}. {q.title}
                                                            </Text>
                                                        ))}
                                                        </>
                                                    )}
                                                </Box>

                                                <Button
                                                    variant="outline"
                                                    backgroundColor="transparent" 
                                                    size={'sm'}
                                                    leftIcon={<MdOutlineEdit />}
                                                    mt={2}
                                                    onClick={() => {
                                                        onMessageModalOpen();
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            </Box>
                                        );
                                        })()}
                                    </>
                                ) : null}

                                {destinationType === 'WEBSITE_AND_LEAD_FORM' ? (
                                    <>
                                        <Flex alignItems="center" gap={2} mt={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Instant form</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>

                                        {/* Table Layout */}
                                        {filteredInstantForms?.length > 0 ? (
                                            <RadioGroup onChange={(value) => singleMediaFormik.setFieldValue('lead_gen_form_id', value)} value={singleMediaFormik.values.lead_gen_form_id} colorScheme="brand" mb={2}>
                                                <Table variant="simple">
                                                    <Thead>
                                                        <Tr>
                                                            <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                        </Tr>
                                                    </Thead>
                                                   <Tbody>
                                                        {filteredInstantForms?.map((form) => (
                                                            <Tr key={form?.id} >
                                                                <Td p={-1}>
                                                                    <Flex alignItems="center" gap={2}>
                                                                        <Radio value={form?.id} />
                                                                        <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                            {truncateString(form?.name, 25)}
                                                                        </Text>
                                                                    </Flex>
                                                                </Td>
                                                                <Td>
                                                                    <Text fontSize={'12px'}>
                                                                        {new Date(form?.created_time).getFullYear()}-
                                                                        {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                        {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                                    </Text>
                                                                </Td>
                                                            </Tr>
                                                        ))}
                                                    </Tbody>
                                                </Table>
                                            </RadioGroup>
                                        ) : (
                                            <Text fontSize="14px" color="gray.500" mb={2}>No form data available</Text>
                                        )}
                                    </>
                                ) : null}

                                {destinationType === 'ON_AD' ? (
                                    <>
                                        <Flex alignItems="center" gap={2} mt={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Instant form</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>

                                        {/* Table Layout */}
                                        {filteredInstantForms?.length > 0 ? (
                                            <RadioGroup onChange={(value) => singleMediaFormik.setFieldValue('link', value)} value={singleMediaFormik.values.link} colorScheme="brand">
                                                <Table variant="simple">
                                                    <Thead>
                                                        <Tr>
                                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                        </Tr>
                                                    </Thead>
                                                   <Tbody>
                                                        {filteredInstantForms?.map((form) => (
                                                            <Tr key={form?.id}>
                                                                <Td>
                                                                    <Flex alignItems="center" gap={2}>
                                                                        <Radio value={form?.id} />
                                                                        <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                            {truncateString(form?.name, 25)}
                                                                        </Text>
                                                                    </Flex>
                                                                </Td>
                                                                <Td>
                                                                    <Text fontSize={'12px'}>
                                                                        {new Date(form?.created_time).getFullYear()}-
                                                                        {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                        {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                                    </Text>
                                                                </Td>
                                                            </Tr>
                                                        ))}
                                                    </Tbody>
                                                </Table>
                                            </RadioGroup>
                                        ) : (
                                            <Text fontSize="14px" color="gray.500" mb={2}>No form data available</Text>
                                        )}
                                    </>
                                ) : null}

                                {(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) && !['PHONE_CALL', 'APP', 'WHATSAPP', 'ON_AD'].includes(destinationType) && singleMediaFormik?.values?.type !== "LIKE_PAGE")  ? 
                                    <Flex direction="column" gap={2} mb={4}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Display link</Text>
                                        <Input
                                            name="caption"
                                            placeholder="Enter the link that you want to show on your ad"
                                            bg="#fff"
                                            size='sm'
                                            borderRadius="md"
                                            value={singleMediaFormik.values.caption}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                    </Flex>
                                :null}

                                {objective === "OUTCOME_AWARENESS" || destinationType === 'ON_VIDEO' ? 
                                    <Flex direction={'column'} gap={1} mb={4}>
                                        <Flex alignItems="center" gap={2} mb={'5px'}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Mobile app</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Select
                                            name={`app_id`}
                                            bg="#fff"
                                            size="sm"
                                            borderRadius="md"
                                            onChange={singleMediaFormik.handleChange}
                                            onBlur={singleMediaFormik.handleBlur}
                                            value={singleMediaFormik?.values?.app_id}
                                        >
                                            <option value="">Choose app</option>
                                            {advertisableApps?.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Flex>
                                :null}
                               
                                {['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(destinationType) ? null :
                                    <Flex direction="column" gap={1}>
                                        <Flex alignItems={'center'}>
                                            <Text mb={'5px'} fontWeight="bold" fontSize={'14px'}>
                                                URL parameters{" "}
                                                {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                                <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                            </Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p={'5px'}>
                                                        <Text >
                                                            Add parameters to the end of your website URL to track where your visitors are coming from.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                            </Tooltip>
                                        </Flex>
                                        <Input
                                            name="url_tags"
                                            placeholder="key1=value1&key2=value2"
                                            bg="#fff"
                                            size='sm'
                                            borderRadius="md"
                                            value={singleMediaFormik.values.url_tags}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                        <Flex mt={1}>
                                            <Button onClick={() => {
                                                setUrlParamModalOpen(true)
                                            }}
                                                variant="link"
                                                color='brand'>
                                                <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                            </Button>
                                        </Flex>
                                    </Flex>
                                }

                                <Flex justifyContent="flex-start" mt={'20px'}>
                                    <Button
                                        colorScheme="brand"
                                        onClick={() => singleMediaFormik.handleSubmit()}
                                        size={'sm'}
                                        isLoading={isAdspressoAdsetUpdating}
                                    >
                                        Save
                                    </Button>
                                </Flex>
                            </Box>
                        </Flex>
                    </Box>
                </Collapse>
            </Box>
        </>
    )
}

export default SingleMediaUpdateForm